.tabsContainer {
  display: flex;
  justify-items: flex-start;
  align-items: center;

  @media (min-width: 1024px) {
    justify-content: space-between;
  }

  width: 100%;
  height: 42px;
  margin: 0 auto;
  padding: 0px 16px;

  background-color: var(--ogm-white);

  @media (min-width: 1024px) {
    justify-content: unset;
    width: calc(100% - 32px);
    padding: 0;

    background-color: unset;
  }

  @media (min-width: 1440px) {
    width: calc(1440px - 32px);
    margin: 0 auto;
  }

  &.oc {
    box-shadow: var(--ogm-box-shadow-1);

    @media (min-width: 1024px) {
      box-shadow: none;
      border-bottom: 1px solid;
      border-color: var(--ogm-border-grey);
      background-color: var(--ogm-white);

      height: 45px;
    }
  }

  &.default {
    border-bottom: 1px solid;
    border-color: var(--ogm-separator);

    @media (min-width: 1024px) {
      height: 56px;
    }
  }

  .tab {
    display: flex;
    align-items: center;

    height: 100%;

    border-bottom: 2px solid transparent;
    cursor: pointer;
    font-family: var(--ogm-font-family-1);

    text-transform: uppercase;
    letter-spacing: 0.5px;

    &.oc {
      font-size: 13px;
      font-weight: 800;
      color: var(--ogm-subtext-grey);

      padding: 0px 12px;
      @media (min-width: 1024px) {
        padding: 12px 20px;
      }
    }

    &.default {
      font-size: 16px;
      font-weight: 700;
      color: var(--ogm-timberwolves);

      padding: 0;
      margin-right: 20px;

      @media (min-width: 1024px) {
        padding: 16px 32px;
        margin-right: unset;
        font-size: 16px;
      }
    }

    &.active {
      @media (min-width: 1024px) {
        border-bottom: 3px solid;
      }

      &.oc {
        border-color: var(--ogm-active-tab-bg-color);
        color: var(--ogm-black);
      }

      &.default {
        border-color: var(--ogm-seahawks);
        color: var(--ogm-timberwolves);
      }
    }

    &.link {
      height: unset;
      padding: 0;
      margin-left: auto;

      @media (min-width: 1024px) {
        margin: 0px 20px;
      }
    }
  }

  .tab:last-child {
    margin-right: unset;
  }
}

.linkWrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 4px;
  border-radius: 3px;
  gap: 5px;

  @media (min-width: 1024px) {
    border: 1px solid var(--ogm-grizzlies);

    &:hover {
      border-color: var(--ogm-timberwolves);

      .text {
        color: var(--ogm-timberwolves);
      }
    }
  }

  .icon {
    margin-top: 5px;
  }

  .text {
    font-family: var(--ogm-font-family-2);
    text-transform: lowercase;
    font-weight: 100;

    color: var(--ogm-timberwolves);
    @media (min-width: 1024px) {
      color: var(--ogm-pelicans);
      margin-bottom: 2px;
    }

    padding-right: 2px;
  }
}
